import UserPreferences from 'models/user_preferences'
import Quimbee from 'quimbee'

class SaveFilterSelectionsWidget {
  constructor() {
    this.preferences = new UserPreferences()
    this.preferenceName = "cle_filters"
  }
  // We don't use this function
  getWidgetState(uiState, _widgetStateOptions) {
    return uiState
  }

  // We don't use this function
  getWidgetSearchParameters(searchParameters, _widgetSearchParametersOptions) {
    return searchParameters
  }

  render(renderOptions) {
    const { helper, state } = renderOptions

    this.updatePreferences(renderOptions.state.disjunctiveFacetsRefinements)
  }
  async updatePreferences(updatedSelections) {
    if (Quimbee.isSignedInUser) {
      const savedSelections = await this.preferences.get(this.preferenceName)

      if (JSON.stringify(savedSelections) !== JSON.stringify(updatedSelections)) {
        if (JSON.stringify(updatedSelections) === '{}') {
          // set this value so that we don't preload filters based on CLE Profile
          updatedSelections = { cleared: true }
        }
        await this.preferences.update(this.preferenceName, updatedSelections)
      }
    }
  }
}

export default SaveFilterSelectionsWidget
